import { apiClient } from "./apiClient";

/**
 * GAP, grounded in real (if incomplete) data: app.UserFeedback (V001) has
 * user_id/rating/comment/timestamp/feature_context/resolved -- enough to
 * build a real weekly trend and a real by-theme/by-tier breakdown (join to
 * app.Users.selected_theme/subscription_tier), which admin.py's existing
 * `sentiment` endpoint doesn't do (it only groups by feature_context). Two
 * things genuinely can't be built from what's stored today, though:
 *   - NPS Score: rating is a 1-5 star scale (CHECK constraint), not the 0-10
 *     "how likely to recommend" scale NPS requires -- needs a dedicated NPS
 *     question/column, not derivable from the existing rating
 *   - Feedback Response Time: `resolved` is a plain BIT with no
 *     resolved_date, so there's no timestamp delta to average
 *   - Keyword Cloud: `comment` text exists, but nothing runs any keyword
 *     extraction over it (would need a lightweight NLP step, client-side or
 *     backend, that doesn't exist yet)
 */
export const sentimentAnalyticsApi = {
  weeklyTrend: () => apiClient.get("/management/analytics/sentiment-trend").then((r) => r.data),
  byTheme: () => apiClient.get("/management/analytics/sentiment-by-theme").then((r) => r.data),
  byTier: () => apiClient.get("/management/analytics/sentiment-by-tier").then((r) => r.data),
  npsScore: () => apiClient.get("/management/analytics/nps").then((r) => r.data),
  keywordCloud: () => apiClient.get("/management/analytics/sentiment-keywords").then((r) => r.data),
  responseTime: () => apiClient.get("/management/analytics/feedback-response-time").then((r) => r.data),
};
